import { jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { useTheme } from '../Flowbite';
var AvatarGroupCounter = function AvatarGroupCounter(_ref) {
  var total = _ref.total,
    href = _ref.href,
    className = _ref.className;
  var theme = useTheme().theme.avatarGroupCounter;
  return _jsxs("a", {
    className: classNames(theme.base, className),
    href: href,
    children: ["+", total]
  });
};
AvatarGroupCounter.displayName = 'Avatar.GroupCounter';
export default AvatarGroupCounter;